module.exports = __webpack_public_path__ + "img/0Q3A3494_L_Foamcore.e9e5852e.jpg";